import { motion } from "framer-motion";
import { WHATWEDO } from "@/constants/testIds";

const ITEMS = [
  {
    key: "trained-agents",
    n: "01",
    img: "/illustrations/trained-agents.png",
    title: "Trained Agents Who Know Your Work",
    body: "We learn your processes during onboarding — your SOPs, your systems, your edge cases — so the people doing the work actually understand it.",
  },
  {
    key: "ally",
    n: "02",
    img: "/illustrations/ally-ai.png",
    title: "Ally, Your AI Assistant",
    body: "Every agent works alongside Ally, an assistant that answers from your processes, surfaces the right checklist, and keeps the work on-procedure in real time.",
  },
  {
    key: "supervisor",
    n: "03",
    img: "/illustrations/supervisor-coaches.png",
    title: "A Supervisor That Coaches",
    body: "A supervising AI reviews the work as it happens and coaches each agent in the moment — flagging a misstep, surfacing the next right move, pulling the whole team up to the level of your best person.",
  },
  {
    key: "reporting",
    n: "04",
    img: "/illustrations/reporting-vault.png",
    title: "Reporting That Just Happens",
    body: "Results land in your Vault automatically, pulled even from legacy systems that don't integrate with anything else. The numbers come to you; you stop chasing them.",
  },
];

export default function WhatWeDo() {
  return (
    <section
      id="whatwedo"
      data-testid={WHATWEDO.root}
      className="relative bg-[#ffffff] border-t border-black/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24 md:pt-36 pb-10 md:pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 mb-16 md:mb-24">
          <div className="md:col-span-3">
            <div className="flex items-center gap-3 font-mono text-[12px] uppercase tracking-[0.3em] text-black/65">
              <span className="eyebrow-bar" aria-hidden="true" />
              <span>What We Do</span>
            </div>
          </div>
          <div className="md:col-span-9">
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tightest max-w-4xl text-[#0a0a0a]">
              Inside every engagement.
              <span className="block italic font-light text-black/65">The four pieces, end to end.</span>
            </h2>
            <p className="mt-8 max-w-2xl font-sans text-black/65 text-base md:text-lg leading-relaxed">
              A working team already on the job for clients across healthcare
              receivables, legal, and financial services — backed by an American
              company based in Florida.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-black/12">
        <div className="max-w-[1400px] mx-auto bg-black/12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px">
            {ITEMS.map((c, idx) => (
              <motion.div
                key={c.key}
                data-testid={WHATWEDO.card(c.key)}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{
                  duration: 0.8,
                  delay: idx * 0.08,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className="group relative bg-[#ffffff] p-8 md:p-12 lg:p-14"
              >
                <img
                  src={c.img}
                  alt=""
                  className="w-full max-w-[280px] aspect-square mx-auto block mb-8"
                />
                <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-black/60 mb-3">
                  {c.n}
                </div>
                <h3 className="font-serif text-3xl md:text-4xl leading-tight tracking-tightest mb-5 max-w-lg text-[#0a0a0a]">
                  {c.title}
                </h3>
                <p className="font-sans text-black/65 text-base leading-relaxed max-w-lg">
                  {c.body}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
